export const SET_USER_CONFIG = 'SET_USER_CONFIG'
export const SET_VERSION = 'SET_VERSION'
export const SET_SHARE_DOMAIN = 'SET_SHARE_DOMAIN'
export const SET_PWD_TEMP = 'SET_PWD_TEMP'
export const SET_ACTIVITY_CONFIG = 'SET_ACTIVITY_CONFIG'
export const SET_TJB_CONFIG = 'SET_TJB_CONFIG'
export const SET_MAIN_ACT = 'SET_MAIN_ACT';
